(function () {
  const TEMPLATE_CLASS = 'template-suffix-horizontal-product';
  const DESKTOP_WIDTH = 769;

  let filterObserver = null;
  let mountTimer = null;
  let isMounting = false;

  function isCorrectPage() {
    return document.body.classList.contains(TEMPLATE_CLASS);
  }

  function closeFilterDropdowns(exceptGroup) {
    document
      .querySelectorAll(
        '.lp-collection-toolbar .collection-sidebar__group'
      )
      .forEach(function (group) {
        if (group === exceptGroup) return;

        const trigger = group.querySelector(
          '.tag-list__header'
        );

        const content = group.querySelector(
          '.collapsible-content--sidebar'
        );

        if (trigger) {
          trigger.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }

        if (content) {
          content.classList.remove('is-open');
          content.style.height = '0px';
        }
      });
  }

  function mountFilterToolbar() {
    if (!isCorrectPage()) return;
    if (window.innerWidth < DESKTOP_WIDTH) return;
    if (isMounting) return;

    const sidebar = document.querySelector(
      '.grid__item--sidebar'
    );

    const collectionWrapper = document.querySelector(
      '.collection-grid__wrapper'
    );

    if (!sidebar || !collectionWrapper) return;
    if (!collectionWrapper.parentNode) return;

    const filterForm =
      sidebar.querySelector(
        '#CollectionSidebar .filter-form'
      ) ||
      sidebar.querySelector('.filter-form');

    const activeTags =
      sidebar.querySelector(
        '#CollectionSidebar .tag-list--active-tags'
      ) ||
      sidebar.querySelector('.tag-list--active-tags');

    const sortBar = collectionWrapper.querySelector(
      '.collection-filter'
    );

    if (!filterForm || !sortBar) return;

    isMounting = true;

    let toolbar = document.querySelector(
      '.lp-collection-toolbar'
    );

    if (!toolbar) {
      toolbar = document.createElement('div');
      toolbar.className = 'lp-collection-toolbar';

      collectionWrapper.parentNode.insertBefore(
        toolbar,
        collectionWrapper
      );
    }

    /*
     * AJAX filtreleme sonrası eski toolbar içeriğini kaldırıp
     * yeni oluşturulan filtre ve sıralama alanını yerleştirir.
     */
    toolbar.innerHTML = '';
    toolbar.appendChild(filterForm);
    toolbar.appendChild(sortBar);

    /*
     * Önceki aktif filtre etiketlerini kaldırır.
     */
    document
      .querySelectorAll(
        '.tag-list--active-tags.lp-mounted-active-tags'
      )
      .forEach(function (oldTags) {
        if (oldTags !== activeTags) {
          oldTags.remove();
        }
      });

    /*
     * Seçili filtreleri toolbarın üstünde pill olarak gösterir.
     */
    if (activeTags && activeTags.children.length > 0) {
      activeTags.classList.add(
        'lp-mounted-active-tags'
      );

      toolbar.parentNode.insertBefore(
        activeTags,
        toolbar
      );
    }

    /*
     * Eski sol sidebar artık gerekli değil.
     */
    sidebar.style.display = 'none';

    document.body.classList.add(
      'lp-toolbar-ready'
    );

    closeFilterDropdowns();

    isMounting = false;
  }

  function scheduleToolbarMount() {
    clearTimeout(mountTimer);

    mountTimer = setTimeout(function () {
      mountFilterToolbar();
    }, 120);
  }

  /*
   * Aynı anda yalnızca bir filtre açık kalır.
   * Boş alana veya ürüne tıklayınca açık filtre kapanır.
   */
  document.addEventListener('click', function (event) {
    if (!isCorrectPage()) return;
    if (window.innerWidth < DESKTOP_WIDTH) return;

    const trigger = event.target.closest(
      '.lp-collection-toolbar .tag-list__header'
    );

    if (trigger) {
      const currentGroup = trigger.closest(
        '.collection-sidebar__group'
      );

      setTimeout(function () {
        closeFilterDropdowns(currentGroup);
      }, 0);

      return;
    }

    const clickedInsideToolbar = event.target.closest(
      '.lp-collection-toolbar'
    );

    if (!clickedInsideToolbar) {
      closeFilterDropdowns();
    }
  });

  function initializeFilterToolbar() {
    if (!isCorrectPage()) return;

    mountFilterToolbar();

    /*
     * Sadece koleksiyon alanını izler.
     * Tüm body'yi sürekli izlemediği için sayfayı yavaşlatmaz.
     */
    const collectionContent =
      document.querySelector('.collection-content') ||
      document.querySelector('.collection-grid') ||
      document.body;

    filterObserver = new MutationObserver(
      function (mutations) {
        const collectionReloaded = mutations.some(
          function (mutation) {
            return Array.from(
              mutation.addedNodes
            ).some(function (node) {
              if (node.nodeType !== 1) return false;

              return (
                node.matches?.(
                  '.grid__item--sidebar, .collection-grid__wrapper'
                ) ||
                node.querySelector?.(
                  '.grid__item--sidebar, .collection-grid__wrapper'
                )
              );
            });
          }
        );

        if (collectionReloaded) {
          scheduleToolbarMount();
        }
      }
    );

    filterObserver.observe(collectionContent, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeFilterToolbar,
      { once: true }
    );
  } else {
    initializeFilterToolbar();
  }

  window.addEventListener('resize', function () {
    scheduleToolbarMount();
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('template-suffix-horizontal-product')) return;
  if (window.innerWidth > 768) return;

  const MODE_TITLES = {
    all: 'All Filters',
    brand: 'Inspired By Brands',
    gender: 'Gender',
    scent: 'Scent Family'
  };

  const GROUP_SELECTORS = {
    brand: '.collection-sidebar__group--1',
    scent: '.collection-sidebar__group--2',
    gender: '.collection-sidebar__group--3',
    availability: '.collection-sidebar__group--4'
  };

  let activeMode = 'all';
  let sheetOpen = false;
  let rebuildTimer = null;

  function nativeDrawer() {
    return document.querySelector('#FilterDrawer');
  }

  function nativeGroup(mode) {
    const drawer = nativeDrawer();
    return drawer && GROUP_SELECTORS[mode]
      ? drawer.querySelector(GROUP_SELECTORS[mode])
      : null;
  }

  function icon(type) {
    if (type === 'filter') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lp-icon-line" d="M4 7h16M4 12h16M4 17h16"/><circle class="lp-icon-fill" cx="9" cy="7" r="2"/><circle class="lp-icon-fill" cx="15" cy="12" r="2"/><circle class="lp-icon-fill" cx="11" cy="17" r="2"/></svg>';
    }
    if (type === 'brand') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lp-icon-fill" d="M4.5 7.5h15v11h-15z"/><path class="lp-icon-line" d="M8.5 7.5V5.5h7v2"/></svg>';
    }
    if (type === 'gender') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lp-icon-fill" d="M12 20.2S4.5 15.7 4.5 9.5A4.5 4.5 0 0 1 12 6.2a4.5 4.5 0 0 1 7.5 3.3c0 6.2-7.5 10.7-7.5 10.7Z"/></svg>';
    }
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lp-icon-fill" d="M12 4.5c4.8 0 7.5 3.2 7.5 7.5S16.8 19.5 12 19.5 4.5 16.8 4.5 12 7.2 4.5 12 4.5Z"/><path class="lp-icon-line" d="M12 7v10M7 12h10"/></svg>';
  }

  function addStyles() {
    if (document.getElementById('lp-filter-sheet-style')) return;
    const style = document.createElement('style');
    style.id = 'lp-filter-sheet-style';
    style.textContent = `
      @media (max-width:768px){
        .template-suffix-horizontal-product .collection-filter{display:none!important}

        .lp-mobile-filterbar{display:grid;grid-template-columns:auto minmax(0,1fr);align-items:center;gap:8px;padding:10px 12px;background:#fff;position:relative;z-index:4;overflow:hidden}
        .lp-mobile-filterbar__scroll{display:flex;align-items:center;gap:8px;min-width:0;overflow-x:auto;-webkit-overflow-scrolling:touch;scrollbar-width:none}
        .lp-mobile-filterbar__scroll::-webkit-scrollbar{display:none}
        .lp-mobile-filterbar button{flex:0 0 auto;display:inline-flex;align-items:center;gap:7px;min-height:38px;border:1px solid #d8d8d8;border-radius:999px;background:#fff;padding:8px 13px;color:#111;font:inherit;font-size:12px;line-height:1;white-space:nowrap}
        .lp-mobile-filterbar__all{position:relative;z-index:2;flex:none!important;border-color:#111!important;box-shadow:8px 0 10px -10px rgba(0,0,0,.55)}
        .lp-mobile-filterbar__icon{width:18px;height:18px;display:inline-flex;align-items:center;justify-content:center}
        .lp-mobile-filterbar__icon svg{width:18px;height:18px;fill:none;stroke:currentColor;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round}
        .lp-mobile-filterbar__icon .lp-icon-fill{fill:transparent;transition:fill .18s ease}
        .lp-mobile-filterbar button.is-selected{background:#fff!important;color:#111!important;border-color:#111!important}
        .lp-mobile-filterbar button.is-selected .lp-icon-fill{fill:currentColor}
        .lp-mobile-filterbar button.is-selected .lp-icon-line{stroke:currentColor}
        .lp-mobile-filterbar__chevron{width:7px;height:7px;border-right:1.5px solid currentColor;border-bottom:1.5px solid currentColor;transform:rotate(45deg) translateY(-2px)}

        .lp-filter-backdrop{position:fixed;inset:0;background:rgba(0,0,0,.34);opacity:0;visibility:hidden;transition:.2s;z-index:9998}
        .lp-filter-backdrop.is-open{opacity:1;visibility:visible}
        .lp-filter-sheet{position:fixed;left:0;right:0;bottom:0;z-index:9999;background:#fff;border-radius:18px 18px 0 0;box-shadow:0 -10px 30px rgba(0,0,0,.14);transform:translateY(105%);transition:transform .24s ease;display:flex;flex-direction:column;width:100%;height:auto!important;min-height:0!important;max-height:80dvh!important;overflow:hidden}
        .lp-filter-sheet.is-open{transform:translateY(0)}
        .lp-filter-sheet__header{flex:0 0 auto;display:flex;align-items:center;justify-content:space-between;min-height:56px;padding:10px 14px 8px 18px;border-bottom:1px solid #ececec}
        .lp-filter-sheet__title{margin:0;font-size:14px;font-weight:600;line-height:1.2}
        .lp-filter-sheet__close{width:38px;height:38px;border:0;background:transparent;padding:0;display:grid;place-items:center}
        .lp-filter-sheet__close svg{width:22px;height:22px;fill:none;stroke:#111;stroke-width:1.8;stroke-linecap:round}
        .lp-filter-sheet__content{flex:0 1 auto;min-height:0;overflow-y:auto;padding:2px 18px 6px;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;touch-action:pan-y}
        .lp-filter-sheet__content.has-internal-scroll{flex:1 1 auto;overflow:hidden;display:flex;flex-direction:column}
        .lp-filter-sheet__footer{flex:0 0 auto;display:flex;align-items:center;justify-content:space-between;gap:16px;padding:12px 18px calc(12px + env(safe-area-inset-bottom));border-top:1px solid #e6e6e6;background:#fff}
        .lp-filter-clear{border:0;background:none;padding:11px 0;text-decoration:underline;font:inherit;font-size:13px}
        .lp-filter-results{border:0;border-radius:999px;background:#000;color:#fff;padding:13px 23px;font:inherit;font-size:12px;font-weight:600;letter-spacing:.02em}

        .lp-filter-sheet .collection-sidebar__group{display:block!important;margin:0!important;padding:0!important;border:0!important}
        .lp-filter-sheet .tag-list__header{display:none!important}
        .lp-filter-sheet .collapsible-content--sidebar{display:block!important;height:auto!important;overflow:visible!important;opacity:1!important;visibility:visible!important}
        .lp-filter-sheet .collapsible-content__inner{padding:0!important}
        .lp-filter-sheet .tag-list{margin:0!important;padding:0!important}
        .lp-filter-sheet li{list-style:none}
        .lp-filter-sheet label{display:flex!important;align-items:center!important;gap:9px!important;min-height:25px!important;margin:0!important;padding:4px 0!important;font-size:13px!important;line-height:1.2!important}
        .lp-filter-sheet input[type="checkbox"],.lp-filter-sheet input[type="radio"]{width:16px!important;height:16px!important;min-width:16px!important;margin:0!important;accent-color:#111}
        .lp-filter-sheet .lp-all-group{padding:5px 0 3px;border-bottom:1px solid #eee}
        .lp-filter-sheet .lp-all-group:last-child{border-bottom:0}
        .lp-filter-sheet .lp-all-heading{font-size:13px;font-weight:600;margin:6px 0 2px}
        .lp-filter-sheet__content.has-internal-scroll>.lp-limited-group{flex:1 1 auto;min-height:0;display:flex!important;flex-direction:column}
        .lp-filter-sheet__content.has-internal-scroll>.lp-limited-group .collapsible-content--sidebar{flex:1 1 auto;min-height:0;max-height:none!important}
        .lp-filter-sheet .lp-limited-group .collapsible-content--sidebar{display:block!important;height:272px!important;max-height:272px!important;min-height:0!important;overflow-x:hidden!important;overflow-y:scroll!important;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;touch-action:pan-y!important;padding-right:8px!important;scrollbar-width:thin;pointer-events:auto!important;position:relative!important}
        .lp-filter-sheet .lp-limited-group .collapsible-content--sidebar::-webkit-scrollbar{width:4px}
        .lp-filter-sheet .lp-limited-group .collapsible-content--sidebar::-webkit-scrollbar-thumb{background:#999;border-radius:999px}

        body.lp-filter-sheet-open{overflow:hidden!important}
        #FilterDrawer{visibility:hidden!important;pointer-events:none!important}
      }
    `;
    document.head.appendChild(style);
  }

  function createBar() {
    const wrapper = document.querySelector('.collection-grid__wrapper');
    if (!wrapper || !wrapper.parentNode) return;

    let bar = document.querySelector('.lp-mobile-filterbar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'lp-mobile-filterbar';
      bar.innerHTML = `
        <button type="button" class="lp-mobile-filterbar__all" data-mode="all"><span class="lp-mobile-filterbar__icon">${icon('filter')}</span><span>FILTER</span></button>
        <div class="lp-mobile-filterbar__scroll">
          <button type="button" data-mode="brand"><span class="lp-mobile-filterbar__icon">${icon('brand')}</span><span>Inspired By</span><span class="lp-mobile-filterbar__chevron"></span></button>
          <button type="button" data-mode="gender"><span class="lp-mobile-filterbar__icon">${icon('gender')}</span><span>Gender</span><span class="lp-mobile-filterbar__chevron"></span></button>
          <button type="button" data-mode="scent"><span class="lp-mobile-filterbar__icon">${icon('scent')}</span><span>Scent family</span><span class="lp-mobile-filterbar__chevron"></span></button>
        </div>
      `;
      bar.addEventListener('click', function (event) {
        const button = event.target.closest('[data-mode]');
        if (!button) return;
        openSheet(button.dataset.mode || 'all');
      });
    }

    if (!document.body.contains(bar)) wrapper.parentNode.insertBefore(bar, wrapper);
    updateBarState();
  }

  function createSheet() {
    if (document.querySelector('.lp-filter-sheet')) return;

    const backdrop = document.createElement('div');
    backdrop.className = 'lp-filter-backdrop';
    backdrop.addEventListener('click', closeSheet);

    const sheet = document.createElement('section');
    sheet.className = 'lp-filter-sheet';
    sheet.setAttribute('aria-hidden', 'true');
    sheet.innerHTML = `
      <div class="lp-filter-sheet__header">
        <h2 class="lp-filter-sheet__title">All Filters</h2>
        <button type="button" class="lp-filter-sheet__close" aria-label="Close">
          <svg viewBox="0 0 24 24"><path d="M5 5l14 14M19 5L5 19"/></svg>
        </button>
      </div>
      <div class="lp-filter-sheet__content"></div>
      <div class="lp-filter-sheet__footer">
        <button type="button" class="lp-filter-clear">Clear all</button>
        <button type="button" class="lp-filter-results">SHOW RESULTS</button>
      </div>
    `;

    sheet.querySelector('.lp-filter-sheet__close').addEventListener('click', closeSheet);
    sheet.querySelector('.lp-filter-results').addEventListener('click', closeSheet);
    sheet.querySelector('.lp-filter-clear').addEventListener('click', clearAll);
    sheet.querySelector('.lp-filter-sheet__content').addEventListener('change', syncSelection);

    document.body.appendChild(backdrop);
    document.body.appendChild(sheet);
  }

  function cleanClone(group) {
    const clone = group.cloneNode(true);
    clone.removeAttribute('id');
    clone.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
    clone.querySelectorAll('[for]').forEach(function (el) { el.removeAttribute('for'); });
    clone.querySelectorAll('input').forEach(function (input) {
      input.dataset.nativeName = input.name || '';
      input.dataset.nativeValue = input.value || '';
      input.removeAttribute('name');
    });
    return clone;
  }

  function rebuildSheet() {
    const sheet = document.querySelector('.lp-filter-sheet');
    if (!sheet) return;

    const content = sheet.querySelector('.lp-filter-sheet__content');
    const title = sheet.querySelector('.lp-filter-sheet__title');
    title.textContent = MODE_TITLES[activeMode] || MODE_TITLES.all;
    content.innerHTML = '';
    content.classList.remove('has-internal-scroll');

    const modes = activeMode === 'all'
      ? ['brand', 'gender', 'scent', 'availability']
      : [activeMode];

    modes.forEach(function (mode) {
      const group = nativeGroup(mode);
      if (!group) return;
      const clone = cleanClone(group);
      const optionCount = clone.querySelectorAll('input').length;
      if (optionCount > 8) {
        clone.classList.add('lp-limited-group');
        if (activeMode !== 'all') content.classList.add('has-internal-scroll');
      }

      if (activeMode === 'all') {
        const wrap = document.createElement('div');
        wrap.className = 'lp-all-group';
        const heading = document.createElement('div');
        heading.className = 'lp-all-heading';
        heading.textContent = MODE_TITLES[mode] || 'Availability';
        wrap.appendChild(heading);
        wrap.appendChild(clone);
        content.appendChild(wrap);
      } else {
        content.appendChild(clone);
      }
    });

    content.querySelectorAll('.lp-limited-group .collapsible-content--sidebar').forEach(enableLimitedScroll);
    updateBarState();
  }

  function enableLimitedScroll(scroller) {
    if (!scroller || scroller.dataset.lpScrollReady === 'true') return;
    scroller.dataset.lpScrollReady = 'true';

    let startY = 0;
    let startScrollTop = 0;

    scroller.addEventListener('wheel', function (event) {
      const before = scroller.scrollTop;
      scroller.scrollTop += event.deltaY;
      if (scroller.scrollTop !== before) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, { passive: false });

    scroller.addEventListener('touchstart', function (event) {
      if (!event.touches || !event.touches.length) return;
      startY = event.touches[0].clientY;
      startScrollTop = scroller.scrollTop;
    }, { passive: true });

    scroller.addEventListener('touchmove', function (event) {
      if (!event.touches || !event.touches.length) return;
      const delta = startY - event.touches[0].clientY;
      const maxScroll = scroller.scrollHeight - scroller.clientHeight;
      if (maxScroll <= 0) return;

      scroller.scrollTop = Math.max(0, Math.min(maxScroll, startScrollTop + delta));
      event.preventDefault();
      event.stopPropagation();
    }, { passive: false });
  }

  function findNativeInput(copyInput) {
    const name = copyInput.dataset.nativeName;
    const value = copyInput.dataset.nativeValue;
    const group = nativeGroup(activeMode) || nativeDrawer();
    if (!group) return null;

    return Array.from(group.querySelectorAll('input')).find(function (input) {
      return (input.name || '') === name && (input.value || '') === value;
    }) || null;
  }

  function syncSelection(event) {
    const copyInput = event.target.closest('input');
    if (!copyInput) return;

    const nativeInput = findNativeInput(copyInput);
    if (!nativeInput) return;

    nativeInput.click();
    setTimeout(updateBarState, 30);
  }

  function clearAll() {
    const drawer = nativeDrawer();
    if (!drawer) return;

    const checked = Array.from(drawer.querySelectorAll('input:checked'));
    if (!checked.length) return;

    checked.forEach(function (input, index) {
      if (index === checked.length - 1) {
        input.click();
      } else {
        input.checked = false;
      }
    });

    setTimeout(function () {
      rebuildSheet();
      updateBarState();
    }, 100);
  }

  function hasSelection(mode) {
    const group = nativeGroup(mode);
    return Boolean(group && group.querySelector('input:checked'));
  }

  function updateBarState() {
    const bar = document.querySelector('.lp-mobile-filterbar');
    if (!bar) return;

    const states = {
      brand: hasSelection('brand'),
      gender: hasSelection('gender'),
      scent: hasSelection('scent')
    };

    Object.keys(states).forEach(function (mode) {
      const button = bar.querySelector('[data-mode="' + mode + '"]');
      if (button) button.classList.toggle('is-selected', states[mode]);
    });

    const all = bar.querySelector('[data-mode="all"]');
    if (all) all.classList.toggle('is-selected', Object.values(states).some(Boolean));
  }

  function openSheet(mode) {
    activeMode = mode;
    sheetOpen = true;
    rebuildSheet();

    const sheet = document.querySelector('.lp-filter-sheet');
    const backdrop = document.querySelector('.lp-filter-backdrop');
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    backdrop.classList.add('is-open');
    document.body.classList.add('lp-filter-sheet-open');
  }

  function closeSheet() {
    sheetOpen = false;
    const sheet = document.querySelector('.lp-filter-sheet');
    const backdrop = document.querySelector('.lp-filter-backdrop');
    if (sheet) {
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
    }
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.classList.remove('lp-filter-sheet-open');
  }

  function scheduleRebuild() {
    clearTimeout(rebuildTimer);
    rebuildTimer = setTimeout(function () {
      createBar();
      if (sheetOpen) rebuildSheet();
      else updateBarState();
    }, 140);
  }

  addStyles();
  createSheet();
  createBar();

  const observer = new MutationObserver(function (mutations) {
    const nativeFilterChanged = mutations.some(function (mutation) {
      return Array.from(mutation.addedNodes).some(function (node) {
        if (node.nodeType !== 1) return false;

        // Kendi oluşturduğumuz drawer/bar içindeki değişiklikleri yok say.
        // Aksi halde rebuildSheet() kendisini tekrar tekrar tetikler ve
        // Inspired By scroll konumu sürekli 0'a döner.
        if (node.closest?.('.lp-filter-sheet, .lp-mobile-filterbar')) return false;

        return (
          node.matches?.('#FilterDrawer, .grid__item--sidebar, .collection-grid__wrapper') ||
          node.querySelector?.('#FilterDrawer, .grid__item--sidebar, .collection-grid__wrapper')
        );
      });
    });

    if (nativeFilterChanged) scheduleRebuild();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});


document.addEventListener('click', function (event) {
  // Yalnızca gerçek ürün görseline tıklanırsa çalışır
  const productImage = event.target.closest(
    '.template-suffix-horizontal-product img.grid-product__image'
  );

  if (!productImage) return;

  const productCard = productImage.closest('.grid-product');
  const productLink = productCard?.querySelector('.grid-product__link');

  if (!productLink || !productLink.href) return;

  event.preventDefault();
  event.stopPropagation();

  window.location.assign(productLink.href);
});